var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCelebration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.11621 1.25098L11.2764 6.67773L17.0078 7.05469L17.3164 7.0752L17.0811 7.27539L12.6816 11.0039L14.126 16.668L14.2031 16.9717L13.9375 16.8047L9 13.6826L4.0625 16.8047L3.79688 16.9717L3.87402 16.668L5.31738 11.0029L0.918945 7.27539L0.683594 7.0752L0.992188 7.05469L6.72266 6.67773L8.88379 1.25098L9 0.958984L9.11621 1.25098ZM7.5791 7.74023L7.5498 7.81348L7.4707 7.81934L3.68652 8.06738L6.5918 10.5264L6.65137 10.5771L6.63281 10.6523L5.68359 14.374L8.93359 12.3213L9 12.2783L9.06641 12.3213L12.3154 14.374L11.3672 10.6523L11.3477 10.5771L11.4082 10.5264L14.3174 8.06738L10.5293 7.81934L10.4502 7.81348L10.4209 7.74023L9 4.16992L7.5791 7.74023Z",
    fill: "#264073",
    stroke: "url(#paint0_linear_60988_10517)",
    strokeWidth: 0.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.33056 12.8787L7.97346 11.3371L5.703 11.0195L4.68766 9.03906L3.67228 11.0195L1.40186 11.3371L3.04476 12.8787L2.65694 15.0554L4.68766 14.0277L6.7184 15.0554L6.33056 12.8787ZM5.63404 13.6187L4.68766 13.1397L3.74127 13.6187L3.92201 12.6043L3.15637 11.8859L4.21444 11.7379L4.68766 10.8149L5.16085 11.7378L6.21895 11.8859L5.4533 12.6043L5.63404 13.6187Z",
    fill: "url(#paint1_linear_60988_10517)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9556 12.8787L16.5985 11.3371L14.328 11.0195L13.3127 9.03906L12.2973 11.0195L10.0269 11.3371L11.6698 12.8787L11.2819 15.0554L13.3127 14.0277L15.3434 15.0554L14.9556 12.8787ZM14.259 13.6187L13.3127 13.1397L12.3663 13.6187L12.547 12.6043L11.7814 11.8859L12.8394 11.7379L13.3127 10.8149L13.7858 11.7378L14.8439 11.8859L14.0783 12.6043L14.259 13.6187Z",
    fill: "url(#paint2_linear_60988_10517)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7056 9.98803L12.3485 8.44648L10.078 8.12888L9.06266 6.14844L8.04728 8.12891L5.77686 8.4465L7.41976 9.98805L7.03194 12.1648L9.06266 11.137L11.0934 12.1647L10.7056 9.98803ZM10.009 10.7281L9.06266 10.2491L8.11627 10.7281L8.29701 9.71366L7.53137 8.99527L8.58944 8.84725L9.06266 7.9243L9.53585 8.84722L10.5939 8.99524L9.8283 9.71363L10.009 10.7281Z",
    fill: "url(#paint3_linear_60988_10517)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_60988_10517",
    x1: 3.13333,
    y1: 3.99219,
    x2: 13.9661,
    y2: 15.3788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C421D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.325272,
    stopColor: "#FBE67B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535488,
    stopColor: "#FCFBE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769917,
    stopColor: "#F7D14E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4A041"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_60988_10517",
    x1: 2.27807,
    y1: 10.0919,
    x2: 6.49375,
    y2: 14.7512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C421D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.325272,
    stopColor: "#FBE67B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535488,
    stopColor: "#FCFBE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769917,
    stopColor: "#F7D14E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4A041"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_60988_10517",
    x1: 10.9031,
    y1: 10.0919,
    x2: 15.1187,
    y2: 14.7512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C421D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.325272,
    stopColor: "#FBE67B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535488,
    stopColor: "#FCFBE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769917,
    stopColor: "#F7D14E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4A041"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_60988_10517",
    x1: 6.65307,
    y1: 7.2013,
    x2: 10.8687,
    y2: 11.8606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C421D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.325272,
    stopColor: "#FBE67B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535488,
    stopColor: "#FCFBE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769917,
    stopColor: "#F7D14E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4A041"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCelebration);
export default __webpack_public_path__ + "static/media/celebration.077229f3fa0c6b8e4592688bcaf7c5a0.svg";
export { ForwardRef as ReactComponent };